module.exports = __webpack_public_path__ + "img/engrenage.df8eefc8.svg";